// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1qcpR","requiredAsterisk":"Info_requiredAsterisk__1wb01"};